import React from "react";
import { Button, Wrapper, Icon } from "app/NativeComponents/common";
import { store } from "app/store";

const CloseButton = ({ style, onPress, color = null }) => {
  const colors = store.getState().settings.colors;

  return (
    <Button
      onPress={onPress}
      style={{
        position: "absolute",
        top: 0,
        right: 0,
        elevation: 5,
        ...style
      }}
    >
      <Wrapper
        style={{
          padding: 10,
          width: 50,
          height: 50,
          alignItems: "flex-end",
          justifyContent: "flex-start"
        }}
      >
        <Icon
          icon="close"
          size={28}
          color={color ? color : colors.light_text_color}
        />
      </Wrapper>
    </Button>
  );
};

export { CloseButton };
